import { useEffect, useState } from 'react'
import { settingsService } from '../services/settings.service'

/**
 * Custom hook za čitanje postavki iz settingsService
 * Automatski se ažurira kada se postavka promeni
 */
export function useSetting<T = any>(key: string, defaultValue?: T): T {
  const [value, setValue] = useState<T>(() => settingsService.get(key) ?? defaultValue)

  useEffect(() => {
    // Subscribe to settings changes
    const unsubscribe = settingsService.subscribe(() => {
      const newValue = settingsService.get(key)
      if (newValue !== undefined) {
        setValue(newValue)
      }
    })

    // Cleanup
    return unsubscribe
  }, [key])

  return value
}
